export enum CompanySubscriptionStatusEnum {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    PAST_DUE = 'PAST_DUE',
    CANCELED = 'CANCELED',
}
